import * as fromDatatype from '../datatype-library/index';

export interface bl_bi_dashboard_blocks_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  dashboard_guid: fromDatatype.GuidDataFieldInterface;
  report_hdr_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.TextDatatypeInterface;
  title: fromDatatype.TextDatatypeInterface;
  chart_type: fromDatatype.VarcharDatatypeInterface;
  x_axis: fromDatatype.VarcharDatatypeInterface;
  y_axis: fromDatatype.VarcharDatatypeInterface;
  aggregation_type: fromDatatype.VarcharDatatypeInterface;
  sort_order: fromDatatype.VarcharDatatypeInterface;
  limit_rows: fromDatatype.IntegerDatatypeInterface;
  grid_x: fromDatatype.IntegerDatatypeInterface;
  grid_y: fromDatatype.IntegerDatatypeInterface;
  grid_cols: fromDatatype.IntegerDatatypeInterface;
  grid_rows: fromDatatype.IntegerDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_bi_dashboard_blocks_RowClass implements bl_bi_dashboard_blocks_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  dashboard_guid: fromDatatype.GuidDataFieldInterface;
  report_hdr_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.TextDatatypeInterface;
  title: fromDatatype.TextDatatypeInterface;
  chart_type: fromDatatype.VarcharDatatypeInterface;
  x_axis: fromDatatype.VarcharDatatypeInterface;
  y_axis: fromDatatype.VarcharDatatypeInterface;
  aggregation_type: fromDatatype.VarcharDatatypeInterface;
  sort_order: fromDatatype.VarcharDatatypeInterface;
  limit_rows: fromDatatype.IntegerDatatypeInterface;
  grid_x: fromDatatype.IntegerDatatypeInterface;
  grid_y: fromDatatype.IntegerDatatypeInterface;
  grid_cols: fromDatatype.IntegerDatatypeInterface;
  grid_rows: fromDatatype.IntegerDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
